import { render, staticRenderFns } from "./OpenApp.vue?vue&type=template&id=2a64c666&scoped=true"
import script from "./OpenApp.vue?vue&type=script&lang=js"
export * from "./OpenApp.vue?vue&type=script&lang=js"
import style0 from "./OpenApp.vue?vue&type=style&index=0&id=2a64c666&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64c666",
  null
  
)

export default component.exports